import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import axios from "axios";
import "./SuperStarContent.css";
import ReactPlayer from "react-player";
import swal from "sweetalert";
import useVdieoHandleS3 from "../../../../CustomHooks/useVideoHandleS3";
import useThumbnailHandleS3 from "../../../../CustomHooks/useThumbnailHandleS3";
import MediaUploadProgressBar from "../../../../Screen/MediaUploadProgressBar";
import { serverInfo } from "../../../../App";
import useVideoHandleWithCompress from "../../../../CustomHooks/useVideoHandleWithCompress";

const EditPromoVideo = () => {
  const history = useHistory();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [event, setEvent] = useState({});
  const { imageCdnUrl, videoCdnUrl } = useContext(serverInfo);
  // Video File Handle
  const videoInputRef = useRef(null);
  const [videoPath, setVideoPath] = useState("");
  const [video, setVideo] = useState('');
  const [videoDelKey, setVideoDelKey] = useState(null);
  const [videoUrl, videoKey, videoProgress, videoHeight,videoWidth] = useVideoHandleWithCompress(video, 'promoVideos', videoDelKey);


  // Thumbnail File Handle
  const thumbInputRef = useRef(null);
  const [thumbPath, setThumbPath] = useState("");
  const [thumbnail, setThumbnail] = useState('');
  const [thumbnailDelKey, setThumbnailDelKey] = useState(null);
  const [thumbImageUrl, thumbImageKey, thumbProgress] = useThumbnailHandleS3(thumbnail, 'promoVideos/thumbnail', thumbnailDelKey);

  const [registerInput, setRegister] = useState({
    title: "",
    video_url: "",
    star_approval: "",
    status: "",
    error_list: [],
  });

  const getPromoVideo = (id) => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get(`/api/star/promoVideo/edit/${id}`).then((res) => {
        if (res.data.status === 200) {
          let promo = res.data.promo_video;
          setRegister({ ...registerInput, title: promo.title });
          setEvent(res.data.promo_video);
          setVideoPath(promo.video_url?promo?.video_url:'');
          setThumbPath(promo.thumbnail?promo?.thumbnail:'');
          // setVideoPath(res.data.post.video?res.data.post.video:'');
          // setThumbPath(res.data.post?.thumbnail?res.data.post?.thumbnail:'');
          console.log('thumbPaththumbPath==>',promo);
        }
      });
    });
  };

  useEffect(() => {
    getPromoVideo(id);
  }, [id]);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setRegister((prev) => {
      return { ...prev, [name]: value };
    });
  };
// Video handle
  const handleVideoChange = (file) => {
    setVideoDelKey(videoKey);
    setVideo('');
    setVideo(file[0]);
  };
  const deleteVideo = () => {
    setVideo('');
    setVideoDelKey(videoKey);
    videoInputRef.current.value = '';
  }

  const handleVideoThumbnailChange = (file) => {
    setThumbnailDelKey(thumbImageKey);
    setThumbnail(file[0]);
  };
  const deleteThumbnail = () => {
    setThumbnail('');
    setThumbnailDelKey(thumbImageKey);
    thumbInputRef.current.value = '';
  }


  const promoUpdate = (e) => {
    setLoading(true);
    e.preventDefault();
    const fData = new FormData();
    fData.append("id", event.id);
    fData.append("title", registerInput.title);
    fData.append("video_url", videoKey ? videoKey : videoPath);
    fData.append("thumbnail", thumbImageKey ? thumbImageKey : thumbPath);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/star/promoVideo/update`, fData).then((res) => {
        setLoading(false);
        if (res.data.status === 200) {
          if (video) {
            setVideo('');
            setVideoDelKey(videoPath.split("com/").pop())
          }
          if (thumbnail) {
            setThumbnail('');
            setThumbnailDelKey(thumbPath.split("com/").pop())
          }

          swal("Success", res.data.message, "success");
          // history.push("/superstar/pending/promoVideo");
          history.goBack();
        } else {
          setRegister({
            ...registerInput,
            error_list: res.data.validation_errors,
          });
        }
      });
    });
  };

  return (
    <>
      <div className="text-light border border-warning rounded-3 d-flex justify-content-center p-2 mb-3">
        <div className="faTrophy">
          <i className="fa-solid fa-calendar-plus"></i>
        </div>
        <h4 className="mx-3 text-warning p-2">Edit Promo Video</h4>
      </div>
      <div className="card card-bg mb-2 p-2 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form
                  className="p-3"
                  onSubmit={promoUpdate}
                  id="input_form"
                  encType="multipart/form-data"
                >
                  <div className="form-group row my-4">
                    <label className="col-sm-12 col-md-4 col-lg-4 label-text ">
                      Title
                    </label>
                    <div className="col-md-8">
                      <input
                        type="text"
                        className="form-control reply-control"
                        placeholder="Enter title here...!"
                        onChange={handleInput}
                        name="title"
                        value={registerInput.title}
                      />
                      <span className="text-danger">
                        {registerInput.error_list?.title}
                      </span>
                    </div>
                  </div>
                  <div className="form-group row my-4">
                    <label
                      for="video_url"
                      className="col-sm-12 col-md-4 col-lg-4 label-text "
                    >
                      Upload Video
                    </label>

                    <div className="col-md-8">
                      <div className="card card-bg m-0 p-0">
                      {videoUrl && video ? (
                        <div className="position-relative">
                          <ReactPlayer
                            url={videoUrl}
                            controls
                            playing={false}
                            volume={1}
                            width="100%"
                            height="200px" // style={{ margin: "0 auto" }}
                          />
                          <span className="text-warning right-cross-button" onClick={deleteVideo}>X</span>
                        </div>
                        ) : <ReactPlayer
                          url={videoCdnUrl + videoPath}
                          controls
                          playing={false}
                          volume={1}
                          width="100%"
                          height="200px" // style={{ margin: "0 auto" }}
                        />}
                        <input
                          type="file"
                          className="form-control reply-control"
                          placeholder="Enter title here...!"
                          onChange={(e) => handleVideoChange(e.target.files)}
                          name="video_url"
                          ref={videoInputRef}
                        />
                        {video && !videoUrl && <MediaUploadProgressBar progress={videoProgress} />}
                        <span className="text-danger">
                          {registerInput.error_list?.video_url}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row my-4">
                    <label
                      for="thumbnail"
                      className="col-sm-12 col-md-4 col-lg-4 label-text "
                    >
                      Upload Video Thumbnail
                    </label>
                    {/* <div className="col-md-8">
                    </div> */}
                    <div className="col-md-8">
                      {thumbImageUrl && thumbnail ? (
                            <div className="position-relative">
                              <img
                                src={thumbImageUrl}
                                className="demo-preview-image img-fluid"
                                alt=""
                                style={{ height: "200px", width: "400px" }}
                              />
                              <span className="text-warning right-cross-button" onClick={deleteThumbnail}>X</span>
                            </div>

                          ) : (
                            <img
                              src={imageCdnUrl + thumbPath}
                              className="demo-preview-image img-fluid"
                              alt=""
                              style={{ height: "200px", width: "400px" }}
                            />
                          )}

                      <input
                        type="file"
                        className="form-control reply-control"
                        placeholder="Enter title here...!"
                        onChange={(e) =>
                          handleVideoThumbnailChange(e.target.files)
                        }
                        name="thumbnail"
                        ref={thumbInputRef}
                      />
                      {thumbnail && !thumbImageUrl && <MediaUploadProgressBar progress={thumbProgress} />}
                      <span className="text-danger">
                        {registerInput.error_list?.thumbnail}
                      </span>
                    </div>
                  </div>

                  {/* Update Submit */}
                  <div className="row justify-content-center aligns-items-center my-4 mt-5">
                    <div className="col-md-3"></div>
                    <div className="col-md-9 d-flex justify-content-center aligns-items-center">
                      {loading ? (
                        <>
                          <button className="btn btnUpdate">
                            <i className="fas fa-spinner fa-pulse"></i>{" "}
                          </button>
                        </>
                      ) : (
                        <button className="btn btnUpdate fw-bold" type="submit">
                          Update
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Update Submit End */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditPromoVideo;
